/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import type { Submission_AllowedFileType as AllowedFileType } from '__generated__/graphql-types';

import { InlineNotification, Typography2 } from '@coursera/cds-core';

import { mediaMaxBytesForAiGrading, mediaMaxSecondsForAiGrading } from 'bundles/grading-common/utils/constants';
import { getAllowedFileTypesForGroups } from 'bundles/grading-common/utils/fileUploadUtils';

import _t from 'i18n!nls/grading-common';

const styles = {
  marginBottom: css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

type Props = {
  allowedFiles: AllowedFileType[];
  isAiGraded?: boolean;
};
const AiFileRestrictionNotification = ({ allowedFiles, isAiGraded }: Props) => {
  return (
    <InlineNotification severity="information" css={styles.marginBottom}>
      <React.Fragment>
        {isAiGraded && (
          <React.Fragment>
            <Typography2 component="p" variant="bodyPrimary">
              <FormattedMessage
                message={_t('Maximum file size: {maxFileSizeMb} GB')}
                maxFileSizeMb={Math.floor(mediaMaxBytesForAiGrading / 1000000000)}
              />
            </Typography2>
            <Typography2 component="p" variant="bodyPrimary">
              <FormattedMessage
                message={_t('Maximum video duration: {maxVideoDuration} minutes')}
                maxVideoDuration={Math.floor(mediaMaxSecondsForAiGrading / 60)}
              />
            </Typography2>
          </React.Fragment>
        )}

        <Typography2 component="p" variant="bodyPrimary">
          <FormattedMessage
            message={_t('Accepted file formats: {allowedFileTypeList}')}
            allowedFileTypeList={getAllowedFileTypesForGroups(allowedFiles).join(', ')}
          />
        </Typography2>
      </React.Fragment>
    </InlineNotification>
  );
};

export default AiFileRestrictionNotification;
